const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
export default months;

export const DELEGATE_ACCESS_ACTIONS = {
  DELEGATE_ACCESS: 'DELEGATE_ACCESS',
  REVOKE_ACCESS: 'REVOKE_ACCESS',
  REGION_USER_LIST: 'REGION_USER_LIST',
  TOGGLE_SHOW_DIALOG: 'TOGGLE_SHOW_DIALOG',
  DELEGATE_ACCESS_RECORDS: 'DELEGATE_ACCESS_RECORDS',
};

export const COMPETITORS_ACTIONS = {
  GET_COMPETITORS: 'GET_COMPETITORS',
  UPDATE_COMPETITORS: 'UPDATE_COMPETITORS',
  SET_LOADING: 'SET_LOADING',
  UPDATE_WEIGHT: 'UPDATE_COMPETITOR_WEIGHT',
};

export const ECRI_ACTIONS = {
  FETCH_DATA: 'FETCH_DATA',
  FETCH_STATS: 'FETCH_STATS',
  SET_REGION_OPTIONS: 'SET_REGION_OPTIONS',
  APPLY_FILTERS: 'APPLY_FILTERS',
  SET_LOADING: 'SET_LOADING',
  TOGGLE_UNIT_DETAILS: 'TOGGLE_UNIT_DETAILS',
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
  SET_UNIT_SIZE: 'SET_UNIT_SIZE',
  SET_REGION: 'SET_REGION',
  SET_STATUS: 'SET_STATUS',
  SET_STORE: 'SET_STORE',
  OPEN_EDIT_MODE: 'OPEN_EDIT_MODE',
  CLOSE_EDIT_MODE: 'CLOSE_EDIT_MODE',
  APPROVE_OFFER: 'APPROVE_OFFER',
  EXCLUDE_OFFER: 'EXCLUDE_OFFER',
  PENDING_OFFER: 'PENDING_OFFER',
  SAVE_OFFER: 'SAVE_OFFER',
  APPROVE_ALL_OFFERS: 'APPROVE_ALL_OFFERS',
  PENDING_ALL_OFFERS: 'PENDING_ALL_OFFERS',
  EXCLUDE_ALL_OFFERS: 'EXCLUDE_ALL_OFFERS',
};

export const MESSAGES = {
  DELEGATE_ACCESS_DATE_RANGE_EXCEPTION: {
    message:
      'Delegation for this destination and given date range already exists',
    type: 'error',
  },
  DELEGATE_ACCESS_SUCCESS: {
    message: 'Access delegated successfully',
    type: 'success',
  },
  COMPETITORS_DATA_FETCH_SUCCESS: {
    message: 'Competitors data fetched succesfully',
    type: 'success',
  },
  COMPETITORS_DATA_FETCH_FAILED: {
    message: 'Competitors data not fetched',
    type: 'success',
  },
  COMPETITORS_DATA_UPDATE_SUCCESS: {
    message: 'Competitors data succesfully updated',
    type: 'success',
  },
  COMPETITORS_DATA_UPDATE_FAILED: {
    message: 'Competitors data update failed',
    type: 'error',
  },
  ECRI_STATS_FETCH_FAILED: {
    message: 'Fetching stats failed',
    type: 'error',
  },
  ECRI_DATA_FETCH_FAILED: {
    message: 'Fetching data failed',
    type: 'error',
  },
  ECRI_OFFER_APPROVED: {
    message: 'Offer has been approved',
    type: 'success',
  },
  ECRI_OFFERS_APPROVED: {
    message: 'All Offers has been approved',
    type: 'success',
  },
  ECRI_OFFER_PENDING: {
    message: 'Status set to pending for selected offer',
    type: 'success',
  },
  ECRI_OFFERS_PENDING: {
    message: 'Status restored to pending for all offers',
    type: 'success',
  },
  ECRI_OFFER_EXCLUDED: {
    message: 'Offer has been excluded',
    type: 'success',
  },
  ECRI_OFFER_SAVED: {
    message: 'Offer has been saved',
    type: 'success',
  },
};

export const UserRoles = {
  superAdmin: 'super-admin',
  admin: 'admin',
  readWrite: 'read-write',
  readOnly: 'read-only',
  reportsOnly: 'reports-only',
};
